import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { observer } from 'mobx-react';
import { T } from '../../../../../../Translations';
import ClickableTooltip from '../../../../../ClickableTooltip';
import { InvitationStatus } from '../../Store/InvitationStore/Types';

interface Props {
  invitationStatus: InvitationStatus;
}
function InactiveIcon({ invitationStatus }: Props) {
  switch (invitationStatus) {
    case 'active':
      return <></>;
    case 'inactive':
      return (
        <ClickableTooltip
          className="ml-1 flex w-1/2 text-center"
          tooltipId={'invitations'}
          tooltipIcon={<ExclamationTriangleIcon className="h-4 w-4" aria-hidden="true" />}
        >
          <T kind="Collection Access Removed" />
        </ClickableTooltip>
      );
  }
}

export default observer(InactiveIcon);
